import reducer, { archSlice } from './slice';

export const { reset, selectElement } = archSlice.actions;

export default reducer;
